var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.getOption().class,style:(_vm.getOption().style)},[_c('span',{staticStyle:{"color":"#606266"}},[_vm._v("\n\t\t"+_vm._s(_vm.getOption().text)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }